import { useConfig } from '@Src/providers/ConfigProvider';
import { styled } from '@mui/material/styles';
import { MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '@Src/providers/TranslationProvider';

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.getContrastText(
    theme.palette.secondary.contrastText,
  ),
  color: theme.palette.secondary.contrastText,
  '& .MuiSelect-select': {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  svg: {
    color: 'inherit',
  },
}));

const LanguageSelector = (): JSX.Element => {
  const { language, supportedLanguages = [] } = useConfig();
  const { translate } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<string>(language);

  const handleLanguageChange = (e: SelectChangeEvent<unknown>): void => {
    const value = e.target.value as string;
    const sixMonthsDate = new Date();
    sixMonthsDate.setMonth(sixMonthsDate.getMonth() + 6); // Expires in 6 months
    setCurrentLanguage(value);
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.set('lang', value);
    window.location.href = pageUrl.toString();
  };

  return (
    <StyledSelect
      id="languageSelector"
      aria-label={translate('Select_language_from_dropdown_menu')}
      onChange={handleLanguageChange}
      value={currentLanguage}
    >
      {supportedLanguages?.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.id}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default LanguageSelector;
